import { render, staticRenderFns } from "./AssignRider.vue?vue&type=template&id=50972f57&scoped=true"
import script from "./AssignRider.vue?vue&type=script&lang=js"
export * from "./AssignRider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50972f57",
  null
  
)

export default component.exports